import React from 'react';
import ico from './light-bulb.svg';

export default function IcoLightBulb() {

  return (
    <img alt="Light Bulb" src={ico} width={144} height={144}/>
  );
}
